/*
  nw-frete.js — calculadora de frete e prazo por CEP, na PDP e no carrinho.

  A tabela vem de nw-frete-tabela.js, GERADO do zonas.json — o mesmo arquivo que escreveu as zonas
  de entrega na Shopify. Aqui nao ha numero cravado.

  Sem backend e sem app: o CEP vira UF por faixa (tabela dos Correios embutida), a UF vira zona, o
  peso em gramas vira faixa. Nenhum servico de terceiro e chamado — o CEP do cliente nao sai do
  navegador. E por isso que nao ha ViaCEP aqui.

  Regra da caixa de peso, igual a da loja (conferida em 21/09/2026 no deliveryProfiles):
    ate 500 g | 501–1000 | 1001–1500 | 1501–2600 | 2601–3800 | 3801–5000 | 5001–7500 | 7501–10000 | acima
  A primeira faixa cujo teto alcanca o peso e a que vale. Peso em gramas e preco em centavos: nada
  de ponto flutuante na comparacao.

  Frete gratis: e uma OPCAO de entrega dentro da zona, condicionada a TOTAL_PRICE >= corte (R$ 150
  em SP; R$ 200 em RJ/MG/DF/GO, ES/PR/SC, RS e MS/MT; nenhum no Norte e Nordeste). Onde a zona nao
  tem corte, esta calculadora NAO fala em frete gratis.

  Tudo delegado no document: a gaveta do carrinho e re-renderizada inteira pela Section Rendering
  API (nw-cart.js troca o innerHTML), entao handler presos no elemento morreriam a cada mudanca.
  Por isso tambem ha um MutationObserver na raiz da gaveta, que repinta o resultado depois da troca.
*/
(function () {
  'use strict';
  if (window.NwFrete) return;

  var T = window.NW_FRETE_TABELA;
  if (!T) return;

  var CHAVE = 'nw_cep';

  /* ---------- guarda-chuva de localStorage (aba anonima pode recusar) ---------- */
  function lerCep() {
    try { return (window.localStorage.getItem(CHAVE) || '').replace(/\D/g, '').slice(0, 8); }
    catch (e) { return ''; }
  }
  function gravarCep(d) {
    try { window.localStorage.setItem(CHAVE, d); } catch (e) { /* aba anonima: segue sem lembrar */ }
  }

  /* ---------- formatacao ---------- */
  function brl(centavos) {
    var v = (Math.round(centavos) / 100).toFixed(2).split('.');
    return 'R$ ' + v[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ',' + v[1];
  }
  function mascara(valor) {
    var d = String(valor || '').replace(/\D/g, '').slice(0, 8);
    return d.length > 5 ? d.slice(0, 5) + '-' + d.slice(5) : d;
  }

  /* ---------- nucleo ---------- */
  function ufDoCep(digitos) {
    if (!/^\d{8}$/.test(digitos)) return null;
    var n = parseInt(digitos, 10);
    for (var i = 0; i < T.cep.length; i++) {
      if (n >= T.cep[i][0] && n <= T.cep[i][1]) return T.cep[i][2];
    }
    return null;
  }

  function zonaDaUf(uf) {
    for (var i = 0; i < T.zonas.length; i++) {
      if (T.zonas[i].ufs.indexOf(uf) !== -1) return T.zonas[i];
    }
    return null;
  }

  function precoDaFaixa(zona, gramas) {
    var g = Math.max(0, Math.round(gramas || 0));
    for (var i = 0; i < zona.faixas.length; i++) {
      var teto = zona.faixas[i][0];
      if (teto === null || g <= teto) return zona.faixas[i][1];
    }
    return zona.faixas[zona.faixas.length - 1][1];
  }

  // { estado: 'ok' | 'cep_curto' | 'cep_desconhecido' | 'sem_entrega', ... }
  function calcular(opcoes) {
    var d = String(opcoes.cep || '').replace(/\D/g, '');
    if (d.length !== 8) return { estado: 'cep_curto' };
    var uf = ufDoCep(d);
    if (!uf) return { estado: 'cep_desconhecido' };
    var z = zonaDaUf(uf);
    if (!z) return { estado: 'sem_entrega', uf: uf, ufNome: T.nome_uf[uf] || uf };

    var total = Math.max(0, Math.round(opcoes.centavos || 0));
    var preco = precoDaFaixa(z, opcoes.gramas);
    var temGratis = typeof z.gratis === 'number' && z.gratis > 0;
    var gratis = temGratis && total >= z.gratis;
    return {
      estado: 'ok',
      uf: uf,
      ufNome: T.nome_uf[uf] || uf,
      zona: z.nome,
      preco: preco,
      gratis: gratis,
      temGratis: temGratis,
      corte: temGratis ? z.gratis : null,
      faltam: temGratis && !gratis ? z.gratis - total : 0,
      base: total,
      prazoMin: z.prazo[0],
      prazoMax: z.prazo[1]
    };
  }

  /* ---------- a escada de desconto, do jeito que a loja aplica ----------
     Dois descontos automaticos ("2 un. 5%" e "3+ un. 7%") presos a uma colecao, com minimo por
     QUANTIDADE TOTAL: tapetes misturados contam juntos e o desconto vale para todos eles. A colecao
     nao esta publicada em canal nenhum, entao o Liquid nao a enxerga — a lista de produtos vem do
     nw-escada.js, gerado dos descontos da propria loja.
     Arredondamento POR UNIDADE, meio para cima, que e o que a Shopify faz (S-78): 4990 x 0,95 =
     4740,5 -> 4741. Conferido contra 5 carrinhos reais em 21/09/2026, ao centavo. */
  function degrauDe(qtd) {
    var E = window.NW_ESCADA;
    if (!E || !E.degraus) return 0;
    var pct = 0;
    for (var i = 0; i < E.degraus.length; i++) {
      if (qtd >= E.degraus[i][0]) pct = E.degraus[i][1];
    }
    return pct;
  }

  function somar(linhas, qtdTapetes) {
    var d = degrauDe(qtdTapetes);
    var t = 0;
    for (var i = 0; i < linhas.length; i++) {
      var l = linhas[i];
      t += l.tapete ? Math.round(l.u * (1 - d / 100)) * l.q : l.u * l.q;
    }
    return t;
  }

  // Devolve o retrato do carrinho, ou null quando nao da para confiar nele.
  function carrinhoDe(caixa) {
    var el = caixa.querySelector('[data-nw-frete-linhas]');
    if (!el || !window.NW_ESCADA) return null;
    var linhas;
    try { linhas = JSON.parse(el.textContent || '[]'); } catch (e) { return null; }
    if (!linhas.length) return null;

    var elegivel = {};
    (window.NW_ESCADA.produtos || []).forEach(function (id) { elegivel[id] = true; });

    var qtd = 0;
    linhas.forEach(function (l) {
      // `l.d` = a loja JA aplicou desconto nesta linha. Isso vale mais que a lista gerada e
      // conserta sozinho um dado velho.
      l.tapete = !!(l.d || elegivel[l.p]);
      if (l.tapete) qtd += l.q;
    });

    var total = parseInt(caixa.getAttribute('data-nw-frete-total'), 10);
    if (isNaN(total)) return null;

    /* A TRAVA. Se o meu modelo nao reproduz, ao centavo, o que o carrinho cobra, eu nao sei
       calcular este carrinho — e ai nao prometo desconto nem corte de frete. Acontece se alguem
       mexer na escada e ninguem regerar o nw-escada.js, ou se entrar um desconto que eu nao modelo.
       Errar em silencio aqui seria prometer preco que o carrinho nao cobra. */
    if (somar(linhas, qtd) !== total) return null;

    var tapetes = linhas.filter(function (l) { return l.tapete; });
    if (!tapetes.length) return { linhas: linhas, qtd: 0, total: total, confiavel: true, maisBarato: null };
    var maisBarato = tapetes.reduce(function (a, l) { return l.u < a.u ? l : a; }).u;
    return { linhas: linhas, qtd: qtd, total: total, confiavel: true, maisBarato: maisBarato };
  }

  /* A linha unica. `corte` = o corte da zona em centavos, ou null quando ainda nao ha CEP (e ai so
     se fala de desconto, nunca de frete). Toda frase sai de calculo: nada de numero fixo. */
  function frasesDoCarrinho(caixa, corte) {
    var c = carrinhoDe(caixa);
    if (!c || !c.confiavel || !c.qtd) return '';

    var dAgora = degrauDe(c.qtd);
    var dDepois = degrauDe(c.qtd + 1);
    var subiu = dDepois > dAgora;

    if (corte && c.total >= corte) return 'Frete grátis liberado.';

    var cruza = false;
    if (corte && c.maisBarato !== null) {
      var novo = c.linhas.concat([{ u: c.maisBarato, q: 1, tapete: true }]);
      cruza = somar(novo, c.qtd + 1) >= corte;
    }

    if (subiu && cruza) return 'Adicione mais 1 tapete: o desconto sobe para ' + dDepois + '% e o frete sai de graça.';
    if (subiu) return 'Adicione mais 1 tapete e o desconto sobe para ' + dDepois + '%.';
    if (cruza) return 'Adicione mais 1 tapete e o frete sai de graça.';
    if (corte) return 'Faltam ' + brl(corte - c.total) + ' para o frete grátis.';
    return '';
  }

  function pintarUpsell(caixa, corte) {
    var raiz = caixa.closest('[data-nw-frete-raiz]');
    if (!raiz) return;                       // a PDP nao tem linha de carrinho
    var el = raiz.querySelector('[data-nw-frete-upsell]');
    if (!el) return;
    var txt = frasesDoCarrinho(caixa, corte);
    el.textContent = txt;
    el.hidden = !txt;
  }

  /* ---------- medicao ---------- */
  // Nao existe padrao de evento proprio neste tema (so os Standard Events da plataforma no
  // theme.liquid). Publicamos pelo canal oficial de evento customizado, que qualquer Web Pixel
  // pode assinar com analytics.subscribe('<nome>'). Se ninguem assinar, nao acontece nada e nada
  // quebra. O CEP NAO vai no payload: e dado pessoal e a UF ja basta para medir.
  function medir(nome, dados) {
    try {
      if (window.Shopify && window.Shopify.analytics && window.Shopify.analytics.publish) {
        window.Shopify.analytics.publish(nome, dados || {});
      }
    } catch (e) { /* medicao nunca derruba a tela */ }
  }

  /* ---------- pintura ---------- */
  function base(caixa) {
    // A PDP manda o par peso/total por evento (muda a cada troca de kit ou de formato);
    // gaveta e /cart trazem o carrinho inteiro no proprio Liquid.
    return {
      gramas: parseInt(caixa.getAttribute('data-nw-frete-peso'), 10) || 0,
      centavos: parseInt(caixa.getAttribute('data-nw-frete-total'), 10) || 0
    };
  }

  /* ---------- espera curta e visivel antes do resultado ----------
     A conta e local e instantanea. Mostrar o numero no mesmo milissegundo em que o cliente termina
     de digitar passa sensacao de chute, e nao de calculo (pedido do Marco, 21/09/2026). Entao ha uma
     pausa curta com rosto: "Calculando frete..." com um giro discreto e barras fantasma no lugar das
     linhas que vao chegar.
     O texto nao mente: nao ha consulta a transportadora nenhuma, so a nossa tabela. Por isso
     "Calculando frete", e nada de "consultando a transportadora".
     A altura do esqueleto e a MESMA do resultado (as linhas ja estao la, so sem texto), entao a
     pagina nao pula quando o resultado entra. */
  function esperaDe(caixa) {
    var v = parseInt(caixa.getAttribute('data-nw-frete-espera'), 10);
    if (isNaN(v)) v = 400;
    return Math.max(0, Math.min(3000, v));
  }

  function cancelar(caixa) {
    if (caixa.__nwEspera) { clearTimeout(caixa.__nwEspera); caixa.__nwEspera = null; }
  }

  // quantas linhas o resultado vai ter — o esqueleto nasce com as mesmas, para nao haver salto
  function temNota(caixa, r) {
    return (caixa.getAttribute('data-nw-frete') || '') === 'pdp' && r && r.estado === 'ok';
  }

  function esqueleto(caixa, r) {
    var saida = caixa.querySelector('[data-nw-frete-saida]');
    if (!saida) return;
    var alvo = alturaDoResultado(saida, montar(caixa, r));
    saida.className = 'nw-fr__saida nw-fr__saida--calculando';
    saida.innerHTML = '<span class="nw-fr__linha-1"><span class="nw-fr__girando" aria-hidden="true"></span>Calculando frete…</span>'
      + '<span class="nw-fr__linha-2 nw-fr__fantasma" aria-hidden="true"></span>'
      + (temNota(caixa, r) ? '<span class="nw-fr__nota nw-fr__fantasma" aria-hidden="true"></span>' : '');
    saida.style.minHeight = alvo ? alvo + 'px' : '';
    saida.hidden = false;
  }

  // o agendador. Todo mundo continua chamando pintar(); quem desenha de fato e o aplicar().
  function pintar(caixa, r, publicar) {
    cancelar(caixa);
    /* Na PDP, digitar o CEP agenda um resultado E pede a base de novo, o que reagenda na mesma hora
       com publicar=false. Sem guardar a intencao, o evento de medicao se perderia justamente no
       caminho mais usado. Ela fica pendurada na caixa ate o resultado ser aplicado. */
    publicar = !!publicar || !!caixa.__nwPublicar;
    caixa.__nwPublicar = false;
    if (!r || r.estado === 'cep_curto') { aplicar(caixa, r, false); return; }
    var ms = esperaDe(caixa);
    if (ms <= 0) { aplicar(caixa, r, publicar); return; }
    caixa.__nwPublicar = publicar;
    // a barra generica e o upsell seguem o resultado que JA esta calculado: mexer neles agora
    // deixa um reflow so, no momento do toque, em vez de dois
    soltarBarra(caixa, r.estado === 'ok', r);
    esqueleto(caixa, r);
    caixa.__nwEspera = setTimeout(function () {
      caixa.__nwEspera = null;
      caixa.__nwPublicar = false;
      if (!document.contains(caixa)) return;   // a gaveta pode ter sido re-renderizada no meio
      aplicar(caixa, r, publicar);
    }, ms);
  }

  // monta o resultado sem pintar: serve para desenhar E para medir a altura antes da espera
  function montar(caixa, r) {
    var onde = caixa.getAttribute('data-nw-frete') || '';
    var cls = 'nw-fr__saida';
    var html = '';
    if (r.estado === 'cep_desconhecido') {
      cls = 'nw-fr__saida nw-fr__saida--erro';
      html = '<span class="nw-fr__linha-1">CEP não encontrado</span>'
           + '<span class="nw-fr__linha-2">Confira os 8 dígitos e tente de novo.</span>';
    } else if (r.estado === 'sem_entrega') {
      cls = 'nw-fr__saida nw-fr__saida--erro';
      html = '<span class="nw-fr__linha-1">Ainda não entregamos nesse CEP</span>'
           + '<span class="nw-fr__linha-2">Não há entrega para ' + esc(r.ufNome) + ' no momento.</span>';
    } else {
      cls = 'nw-fr__saida' + (r.gratis ? ' nw-fr__saida--gratis' : '');
      var prazo = 'chega em ' + r.prazoMin + ' a ' + r.prazoMax + ' dias úteis';
      html = '<span class="nw-fr__linha-1">'
           + (r.gratis ? 'Frete grátis' : 'Frete ' + brl(r.preco))
           + ' <span class="nw-fr__sep" aria-hidden="true">·</span> ' + prazo + '</span>';
      var segunda = [];
      segunda.push(esc(r.ufNome) + ' (' + esc(r.uf) + ')');
      if (r.temGratis && !r.gratis) {
        segunda.push('faltam <strong>' + brl(r.faltam) + '</strong> para o frete grátis');
      }
      html += '<span class="nw-fr__linha-2">' + segunda.join(' <span class="nw-fr__sep" aria-hidden="true">·</span> ') + '</span>';
      /* A barra so existe onde existe meta: zona sem corte nao tem o que encher. Ela mora AQUI
         dentro para a medicao que reserva a altura ja contar com ela (zero salto na entrada). */
      if (r.temGratis && onde !== 'pdp') {
        var pct = r.gratis ? 100 : Math.max(2, Math.min(100, Math.round(r.base * 100 / r.corte)));
        html += '<span class="nw-fr__barra" aria-hidden="true"><span class="nw-fr__barra-i" style="width:' + pct + '%"></span></span>';
      }
      if (onde === 'pdp') {
        html += '<span class="nw-fr__nota">Para a quantidade escolhida acima. No carrinho o frete é recalculado pelo total.</span>';
      }
    }
    return { cls: cls, html: html };
  }

  /* A altura reservada nao pode ser chutada: a mesma frase ocupa 1 linha no /cart e 2 na gaveta,
     que e mais estreita. Entao o resultado e montado num CLONE fora da tela, com a largura real da
     caixa, so para medir — e o esqueleto ja nasce com essa altura. Zero salto quando o numero entra,
     em qualquer largura. O clone leva aria-hidden e nao tem o role=status, para o leitor de tela
     nao anunciar o resultado duas vezes. */
  function alturaDoResultado(saida, final) {
    var pai = saida.parentNode;
    if (!pai) return 0;
    var largura = Math.round(saida.getBoundingClientRect().width || pai.clientWidth || 0);
    if (!largura) return 0;
    var clone = saida.cloneNode(false);
    clone.removeAttribute('id');
    clone.removeAttribute('role');
    clone.removeAttribute('aria-live');
    clone.removeAttribute('data-nw-frete-saida');
    clone.setAttribute('aria-hidden', 'true');
    clone.hidden = false;
    clone.className = final.cls;
    clone.innerHTML = final.html;
    clone.style.cssText = 'position:absolute;left:-9999px;top:0;visibility:hidden;pointer-events:none;'
      + 'box-sizing:border-box;width:' + largura + 'px;min-height:0';
    pai.appendChild(clone);
    // altura fracionaria de proposito: arredondar para cima reservava 1 px a mais e a caixa
    // encolhia esse 1 px quando o resultado entrava
    var h = clone.getBoundingClientRect().height;
    pai.removeChild(clone);
    return h;
  }

  function aplicar(caixa, r, publicar) {
    var saida = caixa.querySelector('[data-nw-frete-saida]');
    if (!saida) return;
    var onde = caixa.getAttribute('data-nw-frete') || '';

    if (!r || r.estado === 'cep_curto') {
      saida.hidden = true;
      saida.className = 'nw-fr__saida';
      saida.innerHTML = '';
      saida.style.minHeight = '';
      soltarBarra(caixa, false, null);
      return;
    }

    var final = montar(caixa, r);
    saida.className = final.cls;
    saida.innerHTML = final.html;
    // a altura natural agora e exatamente a que ficou reservada: tirar a reserva nao mexe em nada
    saida.style.minHeight = '';
    saida.hidden = false;
    soltarBarra(caixa, r.estado === 'ok', r);

    // o evento sai quando o cliente VE o resultado, nao quando a conta foi feita: se ele mexer no
    // CEP durante a espera, a leitura anterior e cancelada e nunca foi vista
    if (publicar && r.estado === 'ok') {
      medir('nw_frete_calculado', {
        onde: onde,
        uf: r.uf, zona: r.zona,
        preco_centavos: r.gratis ? 0 : r.preco,
        frete_gratis: r.gratis,
        prazo_min: r.prazoMin, prazo_max: r.prazoMax
      });
    }
  }

  function esc(s) {
    return String(s).replace(/[&<>"]/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c];
    });
  }

  // Antes do CEP, a gaveta e o /cart so convidam a calcular ("Calcule o frete pelo seu CEP"), sem
  // citar valor de corte: ele muda por zona e no Norte/Nordeste nao existe. Depois que o cliente diz
  // o CEP, quem sabe a verdade e a calculadora, e o convite sai de cena — duas frases diferentes
  // sobre o mesmo frete na mesma tela e promessa quebrada.
  function soltarBarra(caixa, esconder, r) {
    // so a gaveta e o /cart tem barra; sem [data-nw-frete-raiz] por perto (o caso da PDP) nao ha
    // o que esconder — e nada de procurar no document inteiro, senao a PDP apagaria a barra da gaveta
    var raiz = caixa.closest('[data-nw-frete-raiz]');
    if (!raiz) return;
    // o convite "calcule o frete pelo seu CEP" sai de cena depois de atendido
    var barra = raiz.querySelector('[data-nw-frete-barra]');
    if (barra) barra.hidden = !!esconder;
    // a linha unica de upsell segue o mesmo resultado: com zona conhecida ela pode falar de frete;
    // sem zona (ou sem resultado) ela volta a so falar de desconto
    pintarUpsell(caixa, (r && r.estado === 'ok' && r.temGratis) ? r.corte : null);
  }

  /* ---------- a PDP conta o que esta selecionado ---------- */
  // O nw-pdp emite 'nw:frete-base' com { gramas, centavos } a cada calculo dele (troca de formato,
  // de kit ou de plano). Guardamos no proprio no, para a repintura nao depender de evento novo.
  document.addEventListener('nw:frete-base', function (ev) {
    var d = ev.detail || {};
    var caixa = document.querySelector('[data-nw-frete="pdp"]');
    if (!caixa) return;
    caixa.setAttribute('data-nw-frete-peso', String(d.gramas || 0));
    caixa.setAttribute('data-nw-frete-total', String(d.centavos || 0));
    // etiqueta de frete gratis de cada kit: so e verdade depois de saber o CEP
    etiquetasDeKit(d.tiers || []);
    var cep = valorDaCaixa(caixa);
    if (cep.length === 8) pintar(caixa, calcular({ cep: cep, gramas: d.gramas, centavos: d.centavos }), false);
  });

  // Os niveis da escada trazem [{el, centavos, gramas}]; com o CEP na mao, a etiqueta "frete gratis"
  // de cada nivel passa a seguir o corte da zona do cliente, em vez do numero fixo de unidades do
  // setting `frete_min`. Sem CEP, nada muda.
  function etiquetasDeKit(tiers) {
    if (!tiers.length) return;
    var caixa = document.querySelector('[data-nw-frete="pdp"]');
    var cep = caixa ? valorDaCaixa(caixa) : '';
    if (cep.length !== 8) return;
    var uf = ufDoCep(cep);
    var z = uf ? zonaDaUf(uf) : null;
    tiers.forEach(function (t) {
      if (!t.el) return;
      var ok = !!(z && typeof z.gratis === 'number' && z.gratis > 0 && t.centavos >= z.gratis);
      t.el.hidden = !ok;
    });
  }

  /* ---------- entrada ---------- */
  function valorDaCaixa(caixa) {
    var inp = caixa.querySelector('[data-nw-frete-cep]');
    return inp ? String(inp.value || '').replace(/\D/g, '') : '';
  }

  function todasAsCaixas() {
    return Array.prototype.slice.call(document.querySelectorAll('[data-nw-frete]'));
  }

  function rodar(caixa, publicar) {
    var cep = valorDaCaixa(caixa);
    var b = base(caixa);
    var r = calcular({ cep: cep, gramas: b.gramas, centavos: b.centavos });
    pintar(caixa, r, publicar);
    if (cep.length === 8) gravarCep(cep);
    if (r.estado === 'ok') {
      if ((caixa.getAttribute('data-nw-frete') || '') === 'pdp') {
        document.dispatchEvent(new CustomEvent('nw:frete-pede-base'));
      }
    }
    return r;
  }

  function espalhar(digitos) {
    todasAsCaixas().forEach(function (c) {
      var inp = c.querySelector('[data-nw-frete-cep]');
      if (inp && String(inp.value || '').replace(/\D/g, '') !== digitos) inp.value = mascara(digitos);
      if (digitos.length === 8) rodar(c, false);
    });
  }

  document.addEventListener('input', function (ev) {
    var inp = ev.target.closest && ev.target.closest('[data-nw-frete-cep]');
    if (!inp) return;
    var antes = inp.value;
    var depois = mascara(antes);
    if (antes !== depois) inp.value = depois;
    var caixa = inp.closest('[data-nw-frete]');
    if (!caixa) return;
    var d = depois.replace(/\D/g, '');
    if (d.length === 8) { gravarCep(d); rodar(caixa, true); espalhar(d); }
    else pintar(caixa, null, false);
  });

  document.addEventListener('submit', function (ev) {
    var form = ev.target.closest && ev.target.closest('[data-nw-frete-form]');
    if (!form) return;
    ev.preventDefault();
    var caixa = form.closest('[data-nw-frete]');
    if (!caixa) return;
    var r = rodar(caixa, true);
    if (r.estado === 'ok') espalhar(valorDaCaixa(caixa));
  });

  /* ---------- primeira pintura e repintura ---------- */
  function ligarTudo() {
    var lembrado = lerCep();
    todasAsCaixas().forEach(function (c) {
      var inp = c.querySelector('[data-nw-frete-cep]');
      if (inp && !String(inp.value || '').replace(/\D/g, '') && lembrado) inp.value = mascara(lembrado);
      if (valorDaCaixa(c).length === 8) rodar(c, false);
    });
  }

  function observarGaveta() {
    var raiz = document.querySelector('[data-nw-cart]');
    if (!raiz) return;
    var obs = new MutationObserver(function () {
      // a gaveta voltou do servidor com peso e total novos: repinta com o CEP que ja esta na mao
      var c = raiz.querySelector('[data-nw-frete]');
      if (!c) return;
      var lembrado = lerCep();
      var inp = c.querySelector('[data-nw-frete-cep]');
      if (inp && !inp.value && lembrado) inp.value = mascara(lembrado);
      if (valorDaCaixa(c).length === 8) rodar(c, false);
    });
    obs.observe(raiz, { childList: true });
  }

  window.NwFrete = {
    tabela: T,
    calcular: calcular,
    ufDoCep: ufDoCep,
    zonaDaUf: zonaDaUf,
    brl: brl,
    recarregar: ligarTudo
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { ligarTudo(); observarGaveta(); }, { once: true });
  } else {
    ligarTudo();
    observarGaveta();
  }
})();
